import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  loading: false,
  isVisible: false,
  total: 0,
  successCount: 0,
  errorsCount: 0,
  warningsCount: 0,
  reportUrl: null
}

export const content = createSlice({
  name,
  initialState,
  reducers: {
    setLoading: (state, { payload }) => {
      state.loading = payload
    },
    setResults: (state, { payload }) => {
      state.isVisible = true
      state.total = payload.success.length + payload.failed.length + payload.warnings.length
      state.successCount = payload.success.length
      state.errorsCount = payload.failed.length
      state.warningsCount = payload.warnings.length
      state.reportUrl = payload.url || null
    },
    reset: () => initialState
  }
}
)

export const {
  setLoading,
  setResults,
  reset
} = content.actions

export default content.reducer
